import { DateType, DateTypeDeces, DateTypesignature } from "../../types/commonTypes/dateType";

export const  dateInitialState: DateType = {
    date: "",
    effectiveDate: ""
}

export const  dateInitialStatesignature: DateTypesignature = {
    datesignature: "",
    effectiveDatesignature: ""
}

export const  singleDateInitialState: DateType = {
    date: "",
}

export const  dateInitialStateDeces: DateTypeDeces = {
    date: "",
    postalCode:"",
    city:"",
}